import { Injectable } from '@angular/core';
import {  HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { RunPlanTrackLibrariesUpdateDTO } from './runplan_trackLibrariesDTO';

@Injectable({
  providedIn: 'root'
})
export class RunplanTracklibrariesService {

  defaultTimeout = 600000;

  constructor(private http: HttpClient) { }

  getListOfPlannableLibrariesData(requestObj: any): Observable<any> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/trackLibraies/list";
    return this.http.put<any>(url, requestObj).pipe(timeout(environment.defaultTimeout));
  }

  updateActionType(updateActionObj: RunPlanTrackLibrariesUpdateDTO) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/trackLibraies/updateActionList";
    return this.http.patch<any>(url, updateActionObj).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }
}
